module.exports = __webpack_public_path__ + "e671f5b44db2ea40c8721ec9a8a5c24b.png";